interface ClientData {
  device: string
  os: string
  os_version: string
  browser: string
  browser_version: string
  device_vendor: string
  device_model: string
}

function detectOS(userAgent: string): { os: string; os_version: string } {
  if (/Windows/i.test(userAgent)) {
    const match = userAgent.match(/Windows NT (\d+\.\d+)/)
    let os_version = 'unknown'
    if (match) {
      const version = parseFloat(match[1])
      os_version = version === 10.0 ? '10' : match[1]
    }
    return {
      os: 'Windows',
      os_version,
    }
  }
  if (/Mac OS X/i.test(userAgent)) {
    const match = userAgent.match(/Mac OS X (\d+_\d+)/)
    return {
      os: 'macOS',
      os_version: match ? match[1].replace('_', '.') : 'unknown',
    }
  }
  if (/Android/i.test(userAgent)) {
    const match = userAgent.match(/Android (\d+\.\d+)/)
    return {
      os: 'Android',
      os_version: match ? match[1] : 'unknown',
    }
  }
  if (/iOS/i.test(userAgent)) {
    const match = userAgent.match(/OS (\d+_\d+)/)
    return {
      os: 'iOS',
      os_version: match ? match[1].replace('_', '.') : 'unknown',
    }
  }
  return { os: 'unknown', os_version: 'unknown' }
}

function detectBrowser(userAgent: string): {
  browser: string
  browser_version: string
} {
  if (/Chrome/i.test(userAgent) && !/Edge/i.test(userAgent)) {
    const match = userAgent.match(/Chrome\/((?:\d+\.*)*)/)
    return { browser: 'Chrome', browser_version: match ? match[1] : 'unknown' }
  }
  if (/Firefox/i.test(userAgent)) {
    const match = userAgent.match(/Firefox\/((?:\d+\.*)*)/)
    return { browser: 'Firefox', browser_version: match ? match[1] : 'unknown' }
  }
  if (/Safari/i.test(userAgent) && !/Chrome/i.test(userAgent)) {
    const match = userAgent.match(/Version\/((?:\d+\.*)*)/)
    return { browser: 'Safari', browser_version: match ? match[1] : 'unknown' }
  }
  if (/Edge/i.test(userAgent)) {
    const match = userAgent.match(/Edge\/((?:\d+\.*)*)/)
    return { browser: 'Edge', browser_version: match ? match[1] : 'unknown' }
  }
  return { browser: 'unknown', browser_version: 'unknown' }
}

function detectDevice(userAgent: string): {
  device_vendor: string
  device_model: string
} {
  if (/iPhone/i.test(userAgent)) {
    return { device_vendor: 'Apple', device_model: 'iPhone' }
  }
  if (/iPad/i.test(userAgent)) {
    return { device_vendor: 'Apple', device_model: 'iPad' }
  }
  if (/Android/i.test(userAgent)) {
    return { device_vendor: 'Android', device_model: 'unknown' }
  }
  return { device_vendor: 'PC', device_model: 'unknown' }
}

/**
 * Extracts client device and browser information from navigator
 * @returns Client data object with device, OS, browser information
 */
export function getClientData(): ClientData {
  if (typeof navigator === 'undefined') {
    return {
      device: 'unknown',
      os: 'unknown',
      os_version: 'unknown',
      browser: 'unknown',
      browser_version: 'unknown',
      device_vendor: 'unknown',
      device_model: 'unknown',
    }
  }

  const userAgent = navigator.userAgent
  const isMobile =
    /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
  const device = isMobile ? 'mobile' : 'desktop'

  const { os, os_version } = detectOS(userAgent)
  const { browser, browser_version } = detectBrowser(userAgent)
  const { device_vendor, device_model } = detectDevice(userAgent)

  return {
    device,
    os,
    os_version,
    browser,
    browser_version,
    device_vendor,
    device_model,
  }
}
